/* eslint-disable camelcase */
function pushToDataLayer() {
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(arguments);
  }
}
export const recordPageView = (title, path) => {
  pushToDataLayer("set", "page_path", path);
  pushToDataLayer("event", "page_view", {
    page_title: title,
    page_path: path,
    page_location: window.location.href
  });
};
export const recordException = (description, fatal = false) => {
  pushToDataLayer("event", "exception", {
    description,
    fatal
  });
};
export const recordUserId = userName => {
  pushToDataLayer("set", "user_properties", {
    user_id: userName
  });
};
export const recordGroupName = groupName => {
  pushToDataLayer("set", "group_properties", {
    group_name: groupName
  });
};
export const recordCustomEvent = options => {
  const {
    eventLabel,
    eventName,
    eventValue
  } = options;
  if (eventName && eventLabel && eventValue) {
    pushToDataLayer("event", eventLabel, {
      [eventName]: eventValue
    });
  }
};
export const recordCustomEvents = options => {
  const {
    events
  } = options;
  if (Array.isArray(events)) {
    events.map(eventValue => {
      recordCustomEvent({
        ...options,
        eventValue
      });
    });
  }
};